import styles from './tooltip.module.css'

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    tooltip?: string
    tooltipLines?: string[]
    className?: string
}

export const Tooltip = (props: Props) => {
    const { tooltip, tooltipLines, className } = props

    const tooltipValue = tooltipLines ?
        tooltipLines.map((line, index) => <div key={index}>{line} <br /></div>) :
        tooltip

    return (
        <div className={`${styles.tooltip} ${className || ''}`}>
            {tooltipValue}
        </div>
    )
}
